import { render, staticRenderFns } from "./RoadRescueFundDetail.vue?vue&type=template&id=dd652b1a"
import script from "./RoadRescueFundDetail.vue?vue&type=script&lang=js"
export * from "./RoadRescueFundDetail.vue?vue&type=script&lang=js"
import style0 from "./RoadRescueFundDetail.vue?vue&type=style&index=0&id=dd652b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports